import React from 'react';

import { Avatar as SharedAvatar } from '@copilot/ui';
import { API_BASE_URL } from '../../services/httpClient';

// Resolves the web-specific concerns the shared Avatar deliberately
// doesn't know about - building the photo URL from user.avatar_url (a
// relative API path, see backend/schemas/user.py's computed field) and
// the in-flight local preview (overrideSrc, from SettingsPage.jsx's
// upload flow) - then renders the shared, presentation-only Avatar.
function Avatar({ user, className = '', overrideSrc = '' }) {
  const persistedSrc = user?.avatar_url ? `${API_BASE_URL}${user.avatar_url}` : '';
  const src = overrideSrc || persistedSrc;

  return <SharedAvatar src={src} name={user?.full_name} className={className} />;
}

export default Avatar;
